module.exports = __webpack_public_path__ + "img/project3_small.914109ba.webp";